const transformNumber = (value: number | string, decimals?: number) =>
  Number(value)
    .toFixed(decimals || 0)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export { transformNumber };
